import React from "react";
import { HomeTermsAndConditionsUI } from "./HomeTermsAndConditionsUI";

function HomeTermsAndConditions() {
    return (
        <HomeTermsAndConditionsUI />
    );
}

export { HomeTermsAndConditions }
